/**
 * Defines the routes for the application.
 */
export const routes = {
  home: "/",
  book: {
    index: "/book/:locationCode",
    confirmation: "/book/:locationCode/confirmation",
    cancel: "/booking/cancel",
  },
  account: {
    index: "/account",
    login: "/account/login",
    tenantSelection: "/account/tenant-selection",
    register: {
      index: "/account/register/:id/:key",
      confirmation: "/account/register/confirmation",
    },
    password: {
      forgot: {
        index: "/account/forgotPassword",
        confirmation: "/account/forgotPasswordConfirmation",
      },
      reset: {
        index: "/account/resetPassword",
        confirmation: "/account/resetPasswordConfirmation",
      },
    },
    access: {
      request: {
        index: "/account/registrationRequest",
        confirmation: "/account/registrationRequestConfirmation",
      },
    },
  },
  profile: {
    index: "/profile",
    changePassword: "/profile/change-password",
  },
  user: {
    index: "/user",
    details: "/user/:id",
    access: "/user/:id/access",
    delete: "/user/:id/delete",
    invite: "/user/invite",
  },
  calendar: {
    index: "/calendar",
    location: "/calendar/location"
  },
  appointments: {
    index: "/appointments",
  },
  provider: {
    index: "/provider",
    details: "/provider/:id",
    service: "/provider/:id/service",
  },
  serviceType: {
    index: "/service-type",
    details: "/service-type/:id",
    service: "/service-type/:id/service",
  },
  log: {
    index: "/log",
  },
  tenants: {
    index: "/tenant",
  },
  organization: {
    index: "/organization",
    details: "/organization/:id",
    address: "/organization/:id/address",
    location: "/organization/:id/location",
  },
  location: {
    index: "/location",
    details: "/location/:id",
    address: "/location/:id/address",
    pricing: "/location/:id/pricing",
    closure: "/location/:id/closure",
    payments: "/location/:id/payments",
    provider: {
      index: "/location/:id/provider",
      details: "/location/:id/provider/:providerId",
      services: "/location/:id/provider/:providerId/services",
      schedule: "/location/:id/provider/:providerId/schedule",
    }
  },
  host: {
    index: "/host",
    tenant: {
      index: "/host/tenant",
      details: "/host/tenant/:id",
      organization:"/host/tenant/:id/organization",
      features: "/host/tenant/:id/features"
    },
    subscription: {
      index: "/host/subscription",
      details: "/host/subscription/:id",
      history: "/host/subscription/:id/billing-history",
      billingInfo: "/host/subscription/:id/billing-info"
    }
  },
  invoice:{
    index:'/invoice/:locationCode',
    complete:'/invoice/payment-status'
  }
};

export default routes;


